import { Button, Stack, type ButtonProps } from '@sixfold/common-ui';
import { Component } from 'react';

type SemanticSize = 'mini' | 'tiny' | 'small' | 'medium' | 'large' | 'big' | 'huge' | 'massive';

interface Props {
  label: string;
  disabled?: boolean;
  initialButtonColor?: 'red' | 'green' | 'subtle';
  onConfirm: () => void | Promise<void>;
  size?: SemanticSize;
  className?: string;
  showConfirmationProp?: boolean;
  updateConfirmState?: (newState: boolean) => void;
}

interface State {
  showConfirmation: boolean;
}

function mapSize(size: SemanticSize | undefined): ButtonProps['size'] {
  if (size === 'mini' || size === 'tiny') return 'small';
  if (size === 'small') return 'medium';
  return undefined;
}

function mapColor(color: 'red' | 'green' | 'subtle' | undefined): ButtonProps['kind'] {
  if (color === 'red') return 'danger';
  if (color === 'green') return 'primary';
  if (color === 'subtle') return 'subtle';
  return 'neutral';
}

export class ConfirmButton extends Component<Props, State> {
  state = {
    showConfirmation: false,
  };

  showConfirmationButton = () => {
    this.setState({ showConfirmation: true });
  };

  hideConfirmationButton = () => {
    this.setState({ showConfirmation: false });
  };

  handleConfirmationClick = async () => {
    await this.props.onConfirm();
    if (this.props.updateConfirmState !== undefined) {
      return this.props.updateConfirmState(false);
    }
    return this.hideConfirmationButton();
  };

  render() {
    const { disabled, initialButtonColor, label, size, className, showConfirmationProp, updateConfirmState } =
      this.props;
    const { showConfirmation } = this.state;

    if (showConfirmationProp !== undefined ? !showConfirmationProp : !showConfirmation) {
      return (
        <Button
          size={mapSize(size)}
          disabled={disabled}
          kind={mapColor(initialButtonColor)}
          onClick={updateConfirmState !== undefined ? () => updateConfirmState(true) : this.showConfirmationButton}
          className={className}>
          {label}
        </Button>
      );
    }

    return (
      <Stack direction="row" className={className}>
        <Button
          size={mapSize(size)}
          onClick={updateConfirmState !== undefined ? () => updateConfirmState(false) : this.hideConfirmationButton}>
          Cancel
        </Button>
        <Button size={mapSize(size)} kind="primary" onClick={this.handleConfirmationClick}>
          Confirm
        </Button>
      </Stack>
    );
  }
}
